import { ServiceBase, Result } from "./ServiceBase";
import { Product } from '../models/Product';

export default class EmProductService extends ServiceBase {

    /*public static async listByDivision(divisionId: string): Promise<Result<EmProduct[]>> {

        var result = await this.requestJson<EmProduct[]>({
            url: `/api/EmProduct/listByDivision/${divisionId}`,
            method: "GET"            
        });

        return result;
    }

    public static async listByParentProduct(parentId: string): Promise<Result<EmProduct[]>> {

        var result = await this.requestJson<EmProduct[]>({
            url: `/api/EmProduct/list/${parentId}`,
            method: "GET"
        });

        return result;
    }*/

    public static async list(): Promise<Result<Product[]>> {

        var result = await this.requestJson<Product[]>({
            url: `/api/Product/list/`,
            method: "GET"
        });

        return result;
    }

    public static async add(model: Product): Promise<Result<{}>> {

        var result = await this.requestJson<{}>({
            url: `/api/Product/add`,
            method: "POST",
            data: model
        });
        
        return result;
    }

    public static async update(model: Product): Promise<Result<{}>> {

        var result = await this.requestJson<{}>({
            url: `/api/Product/update`,
            method: "POST",
            data: model
        });

        return result;
    }

    public static async delete(productId: string): Promise<Result<{}>> {

        var result = await this.requestJson<{}>({
            url: `/api/Product/${productId}`,
            method: "DELETE"
        });

        return result;
    }


}
